import Splide from '@splidejs/splide';

// Функція для ініціалізації слайдера
function initializeSlider() {
    /**
     * Splide .articles-category mobile sliders executer
     */
    const splideElms = document.querySelectorAll('.articles-category-slider.splide');

    if (splideElms.length) {
        for (var i = 0; i < splideElms.length; i++) {
            new Splide(splideElms[i], {
                perPage: 1.2,
                focus: 0,
            }).mount();
        }
    }

    const slidersWithThumbnails = document.getElementsByClassName('image-slider-with-thumbnails');
    if (slidersWithThumbnails.length > 0) {
        for (let i = 0; i < slidersWithThumbnails.length; i++) {
            const secondarySliderEl = slidersWithThumbnails[i].querySelector('.secondary-slider');
            const secondarySlider = new Splide(secondarySliderEl, {
                rewind: true,
                fixedWidth: 100,
                fixedHeight: 64,
                isNavigation: true,
                gap: 10,
                focus: 'center',
                pagination: false,
                arrows: false,
                cover: true,
                breakpoints: {
                    '600': {
                        fixedWidth: 66,
                        fixedHeight: 40,
                    }
                }
            }).mount();

            const primarySliderEl = slidersWithThumbnails[i].querySelector('.primary-slider');
            const primarySlider = new Splide(primarySliderEl, {
                type: 'fade',
                // heightRatio: 0.5,
                rewind: true,
                pagination: false,
                arrows: true,
                cover: true,
            });

            // Встановити слайдер мініатюр як ціль синхронізації та викликати mount.
            primarySlider.sync(secondarySlider).mount();
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const ajaxUrl = wp_helper.ajax_url;
    const moreWrap = document.getElementById("more-item");
    const sentinel = document.getElementById("click-me");
    const crumbsHost = document.getElementById("breadcrumbs-host"); // якщо нема — ок, просто нічого не робимо

    if (!moreWrap || !sentinel) return;

    let isLoading = false;
    let loadedCount = 0;
    const maxCount = parseInt(sentinel.getAttribute("data-counter") || "5", 10);

    // ---------- helpers ----------
    const parseHTML = (html) => {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp;
    };

    const getBreadcrumbsFromPostEl = (postEl) => {
        const nav = postEl.querySelector("nav.breadcrumbs");
        return nav ? nav.outerHTML : "";
    };

    const setActiveUI = (postEl) => {
        if (!postEl) return;

        const url = postEl.getAttribute("data-url");
        const title = postEl.getAttribute("data-title") || document.title;

        // URL завжди відповідає активному посту (і вниз, і вверх)
        if (url) {
            history.replaceState({ url }, "", url);
        }

        // title (опційно)
        if (title) {
            document.title = title;
        }

        // breadcrumbs (опційно — тільки якщо є хост)
        if (crumbsHost) {
            const crumbs = getBreadcrumbsFromPostEl(postEl);
            if (crumbs) crumbsHost.innerHTML = crumbs;
        }
    };

    // ---------- НАЙНАДІЙНІШИЙ АКТИВНИЙ ПОСТ (center-line tracking) ----------
    let activePostId = null;
    let ticking = false;

    function getPostAtFocusLine() {
        // Лінія фокусу: 35% від верху — зазвичай “читальна зона”.
        // Можеш змінити на 0.5 якщо хочеш строго по центру.
        const focusY = window.innerHeight * 0.35;

        const posts = document.querySelectorAll("section.post");
        if (!posts.length) return null;

        let best = null;
        let bestDist = Infinity;

        posts.forEach((p) => {
            const rect = p.getBoundingClientRect();

            // пост перекриває focusY
            if (rect.top <= focusY && rect.bottom >= focusY) {
                const dist = Math.abs((rect.top + rect.bottom) / 2 - focusY);
                if (dist < bestDist) {
                    bestDist = dist;
                    best = p;
                }
            }
        });

        // Фолбек: якщо focusY не потрапив ні в один пост (рідко, але буває при дуже великих відступах)
        if (!best) {
            let minTop = Infinity;
            posts.forEach((p) => {
                const rect = p.getBoundingClientRect();
                const d = Math.abs(rect.top);
                if (d < minTop) {
                    minTop = d;
                    best = p;
                }
            });
        }

        return best;
    }

    function updateActiveFromScroll() {
        const postEl = getPostAtFocusLine();
        if (!postEl) return;

        const id = postEl.getAttribute("data-post-id");
        const url = postEl.getAttribute("data-url");

        if (!id || !url) return;

        if (id !== activePostId) {
            activePostId = id;
            setActiveUI(postEl);
        }
    }

    function scheduleActiveUpdate() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
            updateActiveFromScroll();
            ticking = false;
        });
    }

    window.addEventListener("scroll", scheduleActiveUpdate, { passive: true });
    window.addEventListener("resize", scheduleActiveUpdate);

    // первинна синхронізація
    scheduleActiveUpdate();

    // ---------- load post ----------
    async function loadPost(direction = "next") {
        if (isLoading) return;
        if (loadedCount >= maxCount) {
            sentinel.textContent = "";
            return;
        }

        const nextId = parseInt(sentinel.getAttribute("data-next") || "0", 10);
        if (!nextId) {
            sentinel.textContent = "";
            return;
        }

        isLoading = true;

        const form = new FormData();
        form.append("action", "load_infinite_post");
        form.append("load_id", nextId);
        form.append("direction", direction);

        try {
            const res = await fetch(ajaxUrl, {
                method: "POST",
                body: form,
                credentials: "same-origin",
            });

            const json = await res.json();

            if (!json || !json.success) {
                sentinel.textContent = "";
                isLoading = false;
                return;
            }

            // якщо більше нема
            if (json.data && json.data.has_more === false) {
                sentinel.textContent = "";
                isLoading = false;
                return;
            }

            const { html, next_id, url } = json.data || {};
            if (!html) {
                sentinel.textContent = "";
                isLoading = false;
                return;
            }

            // (необов’язково) pushState саме в момент підвантаження
            // Це корисно, якщо ти хочеш, щоб Back/Forward браузера “крокували” по підвантаженнях.
            if (url) {
                history.pushState({ url }, "", url);
            }

            // вставляємо HTML
            moreWrap.insertAdjacentHTML("beforeend", html);

            // після вставки — оновимо data-next для наступного завантаження
            sentinel.setAttribute("data-next", String(next_id || 0));

            // Переініціалізація твого слайдера
            if (typeof initializeSlider === "function") {
                initializeSlider();
            }

            loadedCount++;
            isLoading = false;

            // після додавання нового контенту — переобчислити активний пост/URL
            scheduleActiveUpdate();

        } catch (e) {
            console.log("Load failed", e);
            isLoading = false;
        }
    }

    // ---------- observer: load more ----------
    const loadMoreObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                loadPost("next");
            }
        });
    }, {
        root: null,
        threshold: 0.1,
    });

    loadMoreObserver.observe(sentinel);

    // (опційно) якщо хочеш адекватну поведінку back/forward:
    // На popstate просто перейдемо на URL, щоб WP показав нормальний single.
    window.addEventListener('popstate', (event) => {
        if (event.state && event.state.url) {
            window.location.href = event.state.url;
        }
    });
});

// Додаємо обробник подій до батьківського контейнера
document.body.addEventListener('click', function (event) {
    if (event.target && event.target.classList.contains('copy-url')) {
        event.preventDefault();

        var parentLink = event.target.closest('a.social-share__link');

        if (parentLink) {
            var urlToCopy = parentLink.getAttribute('data-url');

            var tempInput = document.createElement('input');
            tempInput.setAttribute('value', urlToCopy);
            document.body.appendChild(tempInput);

            tempInput.select();
            tempInput.setSelectionRange(0, 99999);

            document.execCommand('copy');

            document.body.removeChild(tempInput);

            alert('URL скопійовано в буфер обміну: ' + urlToCopy);
        }
    }
});
